// extracted by mini-css-extract-plugin
var _1 = {"name":"PA-InlineButton","m":{"small":"PA-InlineButton--small","medium":"PA-InlineButton--medium","large":"PA-InlineButton--large","blue":"PA-InlineButton--blue","green":"PA-InlineButton--green","yellow":"PA-InlineButton--yellow","red":"PA-InlineButton--red","white":"PA-InlineButton--white"}};
var _2 = {};
var _3 = {};
export { _1 as "b", _2 as "e", _3 as "m" }
